import {PolicyPreLapse as PolicyPreLapseLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

type PolicyPreLapseProps = {
  policyPreLapseLetter: PolicyPreLapseLetter;
};

const PolicyPreLapse = (props: PolicyPreLapseProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.policyPreLapseLetter.date)} />
      <CardField name="Agent Number" value={props.policyPreLapseLetter.agentNumber} />
      <CardField name="Insured Name" value={props.policyPreLapseLetter.insuredName} />
      <CardField name="Owner Name" value={props.policyPreLapseLetter.ownerName} />
      <CardField name="Owner Address" value={props.policyPreLapseLetter.ownerAddress!.fullAddress} />
      <CardField name="Policy Number" value={props.policyPreLapseLetter.policyNumber} />
    </>
  );
};

export default PolicyPreLapse;
